import React from "react";

import { isiOS, isRunningStandalone } from "./NavbarResponsive";

export default function ContainerResponsive({ children }) {
  const nonStandaloneStyle = { paddingTop: "12vh" };

  return (
    <div
      // onContextMenu={(e) => e.preventDefault()}
      className="container-responsive"
      style={isRunningStandalone() && !isiOS() ? nonStandaloneStyle : {}}
    >
      {children}
    </div>
  );
}
